export default [
    {
        name: 'home-sell.index',
        path: '/home-sell',
        component: () => import('@/views/home-sell/index.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-sell.save',
        path: '/home-sell/save',
        component: () => import('@/views/home-sell/save.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    },
    {
        name: 'home-sell.feedback',
        path: '/home-sell/feedback',
        component: () => import('@/views/home-sell/feedback.vue'),
        meta: {
            openAccess: true,
            layout: 'unauthenticated'
        }
    }
];
